import { EMPTY_OBJECT } from '../../../constants/common'
import { useElementWidthResize } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { MultipleViewTypeListActiveItemPreviewEmpty } from '../MultipleViewTypeListActiveItemPreviewEmpty'

import {
  PREVIEW_MAX_WIDTH_RATIO_TO_CONTAINER,
  PREVIEW_MIN_WIDTH,
  QA_NAME_PREVIEW_RESIZE_HANDLE,
} from './MultipleViewTypeListActiveItemPreview.constants'

import * as styles from './MultipleViewTypeListActiveItemPreview.module.css'

function MultipleViewTypeListActiveItemPreview({
  Component,
  Empty = MultipleViewTypeListActiveItemPreviewEmpty,
  activeItem,
  canResize,
  className = styles.MultipleViewTypeListActiveItemPreview,
  componentProps,
  containerRef,
  emptyProps,
  qaName,
  resizeConfig: {
    initialWidth: resizeInitialWidth,
    maxWidthRatioToContainer:
      resizemaxWidthRatioToContainer = PREVIEW_MAX_WIDTH_RATIO_TO_CONTAINER,
    minWidth: resizeMinWidth = PREVIEW_MIN_WIDTH,
    ...resizeConfig
  } = EMPTY_OBJECT,
}) {
  const { elementProps, resizeHandleProps } = useElementWidthResize({
    ...resizeConfig,
    containerRef,
    initialWidth: resizeInitialWidth,
    maxWidthRatioToContainer: resizemaxWidthRatioToContainer,
    minWidth: resizeMinWidth,
  })

  return (
    <div
      {...elementProps}
      {...(qaName ? getQaSelector({ value: qaName }) : null)}
      className={className}
    >
      {canResize ? (
        <div
          {...resizeHandleProps}
          {...(qaName
            ? getQaSelector({
                context: qaName,
                value: QA_NAME_PREVIEW_RESIZE_HANDLE,
              })
            : null)}
          className={styles.resizer}
        />
      ) : null}
      {activeItem ? (
        <Component
          {...componentProps}
          activeItem={activeItem}
          key={activeItem}
        />
      ) : (
        <Empty {...emptyProps} />
      )}
    </div>
  )
}

export default MultipleViewTypeListActiveItemPreview
